import type { UnitRule } from '../../interfaces/common/unit-rule';

const CENTIMETERS = { name: 'centimeters', factor: 0.01 } as const;
const TONNES = { name: 'tonnes', factor: 1_000 } as const;

const meters = (max: number) =>
  ({ unit: 'm', decimalPlaces: 2, max, mistakenUnit: CENTIMETERS }) as const;

export const UNIT_RULES = {
  vehicleLength: meters(2_600),
  vehicleWidth: meters(300),
  vehicleHeight: meters(450),
  cargoLength: meters(1_600),
  cargoWidth: meters(260),
  cargoHeight: meters(320),
  vehicleWeight: {
    unit: 'kg',
    decimalPlaces: 0,
    min: 500,
    max: 44_000,
    mistakenUnit: TONNES,
  },
  goodsWeight: {
    unit: 'kg',
    decimalPlaces: 0,
    min: 45,
    max: 44_000,
    mistakenUnit: TONNES,
  },
  volume: { unit: 'm³', decimalPlaces: 3, max: 120_000 },
  loadingMeters: { unit: 'LDM', decimalPlaces: 2, max: 1_600 },
} satisfies Record<string, UnitRule>;

export type UnitRuleField = keyof typeof UNIT_RULES;
